import { render, staticRenderFns } from "./userLabel.vue?vue&type=template&id=270d1623&scoped=true&"
import script from "./userLabel.vue?vue&type=script&lang=js&"
export * from "./userLabel.vue?vue&type=script&lang=js&"
import style0 from "./userLabel.vue?vue&type=style&index=0&id=270d1623&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270d1623",
  null
  
)

export default component.exports